import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import logolight from "../assets/images/logo-light.png";
import profileIcon from "../assets/images/users/user-dummy-img.jpg";

interface UserData {
    fullName: string;
    email: string;
    profile_image_url: string;
}

const Header = () => {
    const [userData, setUserData] = useState<UserData | null>(null);

    useEffect(() => {
        const storedUserDataString = localStorage.getItem("userData");
        
        if (storedUserDataString) {
            try {
                const parsedUserData: UserData = JSON.parse(storedUserDataString);
                setUserData(parsedUserData);
            } catch (error) {
                console.error("Error parsing user data from localStorage:", error);
            }
        }
    }, []);

    return (
        <Navbar className="navbar-expand-lg" id="navbar" expanded={false}>
            <Container>
                {/* Left Logo */}
                <Navbar.Brand as={Link} to="/">
                    <img
                        src={logolight}
                        alt="Your Logo"
                        height="80"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>

                {/* Navbar Toggle for Mobile */}
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                
                {/* Navbar Links */}
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                    <Nav className="mr-auto">
                    
                    <Nav.Link 
                        as="a" 
                        href="https://atcef.com/faq/" 
                        className="mx-4 text-dark" 
                        style={{ fontSize: "1rem", fontWeight: 500 }}
                    >
                        FAQ
                    </Nav.Link>
                    <Nav.Link 
                        as="a" 
                        href="https://atcef.com/contact-us/" 
                        className="mx-4 text-dark" 
                        style={{ fontSize: "1rem", fontWeight: 500 }}
                    >
                        Contact
                    </Nav.Link>

                    </Nav>

                    {/* Profile Dropdown */}
                    <div className="dropdown header-item dropdown-hover-end">
                        <Dropdown>
                            <Dropdown.Toggle 
                                variant="link" 
                                id="page-header-user-dropdown" 
                                bsPrefix="btn" 
                                className="btn btn-icon btn-topbar btn-link rounded-circle" 
                                as="a"
                            >
                                <img
                                    src={userData?.profile_image_url || profileIcon}
                                    alt="Profile"
                                    height="40"
                                    className="d-inline-block align-top rounded-circle header-profile-user"
                                />
                                <span className="mdi mdi-chevron-down d-none d-sm-inline-block"></span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu-end">
                                <Dropdown.Item as={Link} to="/settings">Settings</Dropdown.Item>
                                <Dropdown.Item as={Link} to="/signin">Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
